import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { productsApi } from "services/products/service";

import type { IAnswer, IInvestProfileData } from "./types";

const initialState: IInvestProfileData = {
  investorStatus: null,
  agreementId: null,
  investmentCurrency: "",
  risksForGoal: "",
  clientExpectedReturn: null,
  monthlyAvgIncome: null,
  monthlyAvgExpenses: null,
  assetsSetsUk: false,
  answers: [],
  goalsCurrencies: null,
  goalsData: null,
  investmentCurrencyLabel: "",
  entranceSurveyPage: "",
};

export const investProfileSlice = createSlice({
  name: "investProfile",
  initialState,
  reducers: {
    setInvestorStatus: (state, { payload }: PayloadAction<number | null>) => {
      state.investorStatus = payload;
    },
    setAgreementId: (state, { payload }: PayloadAction<string | null>) => {
      state.agreementId = payload;
    },
    setInvestmentCurrency: (state, { payload }: PayloadAction<string>) => {
      state.investmentCurrency = payload;
    },
    setRisksForGoal: (state, { payload }: PayloadAction<string>) => {
      state.risksForGoal = payload;
    },
    setClientExpectedReturn: (
      state,
      { payload }: PayloadAction<number | null>
    ) => {
      state.clientExpectedReturn = payload;
    },
    setMonthlyAvgIncome: (state, { payload }: PayloadAction<number | null>) => {
      state.monthlyAvgIncome = payload;
    },
    setMonthlyAvgExpenses: (
      state,
      { payload }: PayloadAction<number | null>
    ) => {
      state.monthlyAvgExpenses = payload;
    },
    setAssetsSetsUk: (state, { payload }: PayloadAction<boolean>) => {
      state.assetsSetsUk = payload;
    },
    /** Добавляет значение в массив ответов, предварительно удалив
     * элемент с таким же кодом
     */
    addAnswer: (state, { payload }: PayloadAction<IAnswer>) => {
      state.answers = state.answers.filter(
        (item) => item.questionCode !== payload.questionCode
      );
      state.answers?.push(payload);
    },
    setInvestmentCurrencyLabel: (state, { payload }: PayloadAction<string>) => {
      state.investmentCurrencyLabel = payload;
    },
    setEntranceSurveyePage: (state, { payload }: PayloadAction<string>) => {
      state.entranceSurveyPage = payload;
    },

    clearGoalCurrencies: (state) => {
      {
        state.goalsCurrencies = [];
      }
    },
    clearStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      productsApi.endpoints.getGoalsCurrencies.matchFulfilled,
      (state, action) => {
        state.goalsCurrencies = action.payload.body.currencies;
      }
    );

    builder.addMatcher(
      productsApi.endpoints.getGoalsData.matchFulfilled,
      (state, action) => {
        state.goalsData = action.payload.body.risksForGoal;
      }
    );
  },
});

export const investProfileSliceActions = investProfileSlice.actions;
